<script>
import { FRAUD_COLORS, FRAUD_LABELS, INDIKASI_LABELS } from '../const'

export default {
  name: 'FilterKecurangan',
  props: {
    listOrganisasi: {
      type: Array,
      default: () => []
    },
    loadingOrganisasi: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      filters: {
        tgl_awal: null,
        tgl_akhir: null,
        organisasi_id: null,
        jenis_indikasi: [],
        level: null,
      },
      searchOrganisasi: null,
    }
  },
  computed: {
    levelOptions() {
      return [
        { text: FRAUD_LABELS.low, value: 'low', color: FRAUD_COLORS.low },
        { text: FRAUD_LABELS.medium, value: 'medium', color: FRAUD_COLORS.medium },
        { text: FRAUD_LABELS.high, value: 'high', color: FRAUD_COLORS.high },
        { text: FRAUD_LABELS.none, value: 'none', color: FRAUD_COLORS.none },
      ]
    },
    jenisIndikasiOptions() {
      return [
        { text: INDIKASI_LABELS.lokasi, value: 'lokasi' },
        { text: INDIKASI_LABELS.versi, value: 'versi' },
      ]
    },
  },
  methods: {
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    onFilter() {
      const filterPayload = {
        tgl_awal: this.filters.tgl_awal,
        tgl_akhir: this.filters.tgl_akhir,
        organisasi_id: this.filters.organisasi_id,
        organisasi_nama: this.getOrganisasiNama(this.filters.organisasi_id),
        jenis_indikasi: this.filters.jenis_indikasi,
        level: this.filters.level,
      }
      console.log('Emitting filter:', filterPayload)
      this.$emit('filter', filterPayload)
      this.close()
    },
    getOrganisasiNama(id) {
      if (!id) return null
      const org = this.listOrganisasi.find(o => o.id === id)
      return org ? org.nama : null
    },
    onReset() {
      this.filters = {
        tgl_awal: null,
        tgl_akhir: null,
        organisasi_id: null,
        jenis_indikasi: [],
        level: null,
      }
      this.searchOrganisasi = null
    }
  }
}
</script>

<template>
  <v-dialog scrollable v-model="dialog" max-width="600">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat color="primary">
          <v-toolbar-title class="white--text">
            Filter Indikasi Kecurangan
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-container class="black--text my-2">
          <v-row no-gutters dense>
            <!-- Rentang Presensi -->
            <v-col cols="12" md="12" sm="12">
              <div class="mb-1">
                <span class="primary--text font-weight-medium">Rentang Presensi</span>
              </div>
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <m-datepicker
                    v-model="filters.tgl_awal"
                    dense
                    single-line
                    outlined
                    label="Tanggal Awal"
                    hint="Tanggal Awal"
                  ></m-datepicker>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <m-datepicker
                    v-model="filters.tgl_akhir"
                    dense
                    single-line
                    outlined
                    label="Tanggal Akhir"
                    hint="Tanggal Akhir"
                    :min="filters.tgl_awal"
                  ></m-datepicker>
                </v-col>
              </v-row>
            </v-col>

            <!-- Nama Organisasi -->
            <v-col cols="12" md="12" sm="12">
              <div class="mb-1">
                <span class="primary--text font-weight-medium">Nama Organisasi</span>
              </div>
              <v-autocomplete
                v-model="filters.organisasi_id"
                dense
                outlined
                single-line
                placeholder="Cari Organisasi"
                label="Nama Organisasi"
                :items="listOrganisasi"
                :loading="loadingOrganisasi"
                item-text="nama"
                item-value="organisasi_id"
                clearable
              >
                <template v-slot:item="{ item }">
                  <div class="text-left">
                    <div class="font-weight-medium">{{ item.nama }}</div>
                    <div class="text-caption grey--text">{{ item.kode_organisasi }}</div>
                  </div>
                </template>
                <template v-slot:selection="{ item }">
                  {{ item.nama }}
                </template>
                <template v-slot:no-data>
                  <v-list-item v-if="!loadingOrganisasi">
                    <v-list-item-title class="text-center">Organisasi tidak ditemukan</v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="12" sm="12">
              <div class="mb-1">
                <span class="primary--text font-weight-medium">Jenis Indikasi</span>
              </div>
              <v-select
                v-model="filters.jenis_indikasi"
                dense
                outlined
                single-line
                placeholder="Pilih Jenis Indikasi"
                label="Jenis Indikasi"
                :items="jenisIndikasiOptions"
                multiple
                chips
                clearable
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
        <v-divider class="my-2"></v-divider>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="orange" dark depressed @click="onReset"><v-icon left>mdi-autorenew</v-icon> Reset</v-btn>
        <v-btn color="primary" depressed @click="onFilter"><v-icon left>mdi-check</v-icon> Terapkan</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>

